<template>
  <v-form @submit.prevent="submit">
    <v-sheet rounded class="px-6 py-4 mb-8">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            label="Staré heslo"
            type="password"
            outlined
            hide-details="auto"
            autocomplete="current-password"
            v-model="currentPassword"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="Nové heslo"
            type="password"
            :error-messages="getValidationsErrors('newPassword')"
            outlined
            hide-details="auto"
            autocomplete="new-password"
            v-model="newPassword"
            @input="isValid('newPassword')"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="Nové heslo znovu"
            :error-messages="getValidationsErrors('newPasswordAgain')"
            type="password"
            outlined
            hide-details="auto"
            autocomplete="new-password"
            v-model="newPasswordAgain"
            @input="isValid('newPasswordAgain')"
          />
        </v-col>
      </v-row>
    </v-sheet>
    <v-alert
      v-if="apiResponseState.status === 200"
      type="success"
      outlined
      text
      class="mb-4"
    >
      <div>
        Heslo bylo úspěšně změněno.
      </div>
    </v-alert>
    <v-alert
      v-if="apiResponseState.status > 201"
      type="error"
      outlined
      text
      class="mb-4"
    >
      <div v-if="apiResponseState.status === 401">
        Staré heslo se neshoduje s aktuálním heslem.
      </div>
      <div v-else>
        Něco se pokazilo
      </div>
    </v-alert>
    <div class="text-center">
      <v-btn color="primary" class="c-btn" type="submit">
        Změnit heslo
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { minLength, required, sameAs } from "vuelidate/lib/validators"
import validation from "@/mixins/validation"
import { call, get } from "vuex-pathify"

export default {
  mixins: [validation],
  data() {
    return {
      validationMessages: {
        newPassword: {
          required: "Heslo musí být zadáno",
          minLength: "Heslo musí být dlouhé alespoň 4 znaky",
        },
        newPasswordAgain: {
          sameAs: "Hesla se musejí shodovat",
        },
      },
      currentPassword: "",
      newPassword: "",
      newPasswordAgain: "",
    }
  },
  validations: {
    newPassword: {
      required,
      minLength: minLength(4),
    },
    newPasswordAgain: {
      sameAs: sameAs("newPassword"),
    },
  },
  computed: {
    ...get("app", ["apiResponseState"]),
  },
  methods: {
    ...call("auth", ["changePassword"]),
    submit() {
      if (this.isValid()) {
        this.changePassword({
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
        }).then(() => {
          this.currentPassword = ""
          this.newPassword = ""
          this.newPasswordAgain = ""
        })
      }
    },
  },
}
</script>
